import React from 'react';
import { About, Footer, Header, Skills, Testimonial, Work } from './container';
import { TextGame, ChessGame, TicTacGame } from './container/Games';
import { Education, OtherSkills } from './container/LearnMore';
import { BrowserRouter as Router } from 'react-router-dom';
import { Navbar } from './components';
import './App.scss';
function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <Header />
        <About />
        <Work />
        <Skills />
        <Testimonial />
        <Education />
        <OtherSkills />
        <TextGame />
        <ChessGame />
        <TicTacGame />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
